const flagImageMap = {
  USD: 'https://flagcdn.com/w40/us.png',
  EUR: 'https://flagcdn.com/w40/eu.png',
  EUR_PT: 'https://flagcdn.com/w40/pt.png',
  EUR_DE: 'https://flagcdn.com/w40/de.png',
  EUR_GR: 'https://flagcdn.com/w40/gr.png',
  EUR_FR: 'https://flagcdn.com/w40/fr.png',
  EUR_IT: 'https://flagcdn.com/w40/it.png',
  EUR_ES: 'https://flagcdn.com/w40/es.png',
  EUR_NL: 'https://flagcdn.com/w40/nl.png',
  EUR_BE: 'https://flagcdn.com/w40/be.png',
  EUR_AT: 'https://flagcdn.com/w40/at.png',
  EUR_IE: 'https://flagcdn.com/w40/ie.png',
  EUR_LU: 'https://flagcdn.com/w40/lu.png',
  EUR_FI: 'https://flagcdn.com/w40/fi.png',
  EUR_SK: 'https://flagcdn.com/w40/sk.png',
  EUR_SI: 'https://flagcdn.com/w40/si.png',
  EUR_EE: 'https://flagcdn.com/w40/ee.png',
  EUR_LV: 'https://flagcdn.com/w40/lv.png',
  EUR_LT: 'https://flagcdn.com/w40/lt.png',
  EUR_CY: 'https://flagcdn.com/w40/cy.png',
  EUR_MT: 'https://flagcdn.com/w40/mt.png',
  GBP: 'https://flagcdn.com/w40/gb.png',
  JPY: 'https://flagcdn.com/w40/jp.png',
  CNY: 'https://flagcdn.com/w40/cn.png',
  AUD: 'https://flagcdn.com/w40/au.png',
  CAD: 'https://flagcdn.com/w40/ca.png',
  CHF: 'https://flagcdn.com/w40/ch.png',
  SEK: 'https://flagcdn.com/w40/se.png',
  DKK: 'https://flagcdn.com/w40/dk.png',
  NOK: 'https://flagcdn.com/w40/no.png',
  NZD: 'https://flagcdn.com/w40/nz.png',
  SGD: 'https://flagcdn.com/w40/sg.png',
  HKD: 'https://flagcdn.com/w40/hk.png',
  CZK: 'https://flagcdn.com/w40/cz.png',
  HUF: 'https://flagcdn.com/w40/hu.png',
  RON: 'https://flagcdn.com/w40/ro.png',
  BGN: 'https://flagcdn.com/w40/bg.png',
  HRK: 'https://flagcdn.com/w40/hr.png',
  INR: 'https://flagcdn.com/w40/in.png',
  KRW: 'https://flagcdn.com/w40/kr.png',
  THB: 'https://flagcdn.com/w40/th.png',
  VND: 'https://flagcdn.com/w40/vn.png',
  MYR: 'https://flagcdn.com/w40/my.png',
  PHP: 'https://flagcdn.com/w40/ph.png',
  BRL: 'https://flagcdn.com/w40/br.png',
  ARS: 'https://flagcdn.com/w40/ar.png',
  CLP: 'https://flagcdn.com/w40/cl.png',
  COP: 'https://flagcdn.com/w40/co.png',
  PEN: 'https://flagcdn.com/w40/pe.png',
  ZAR: 'https://flagcdn.com/w40/za.png',
  NGN: 'https://flagcdn.com/w40/ng.png',
  EGP: 'https://flagcdn.com/w40/eg.png',
  KES: 'https://flagcdn.com/w40/ke.png',
  GHS: 'https://flagcdn.com/w40/gh.png',
  AED: 'https://flagcdn.com/w40/ae.png',
  SAR: 'https://flagcdn.com/w40/sa.png',
  QAR: 'https://flagcdn.com/w40/qa.png',
  ILS: 'https://flagcdn.com/w40/il.png',
  TRY: 'https://flagcdn.com/w40/tr.png',
  '...': 'https://flagcdn.com/w40/xx.png',
};

export default flagImageMap;
